<!-- tap to top -->
<div class="tap-top top-cls" (click)="tapToTop()" 
	[ngStyle]="{ 'display': show ? 'block' : 'none' }">
    <div>
      <i class="fa fa-angle-double-up"></i>
    </div>
</div>
<!-- tap to top -->